import i18n from '../../localization';

export enum FlowType {
    Subcritical,
    Supercritical,
    Critical,
}

export const FlowTypeMapLabel = () => ({
    [FlowType.Subcritical]: i18n.t('flowType_subcritical'),
    [FlowType.Supercritical]: i18n.t('flowType_supercritical'),
    [FlowType.Critical]: i18n.t('flowType_critical'),
});
